export const getErrorMsg = (err) => {
  let errorMessage = 'Something went wrong';
  if (!err) return errorMessage;

  const errorResponse = err.response;
  const data = err.data;

  if (errorResponse) {
    const errorData = errorResponse.data;
    if (errorData) {
      if (errorData.message && typeof errorData.message === 'string')
        errorMessage = errorData.message;
      else if (errorData.error && typeof errorData.error === 'string')
        errorMessage = errorData.error;
    }
  } else if (data) {
    if (Array.isArray(data) && data[0] && typeof data[0] === 'string') {
      errorMessage = data[0];
    } else if (data.message && typeof data.message === 'string') {
      errorMessage = data.message;
    } else if (data.msg && typeof data.msg === 'string') {
      errorMessage = data.msg;
    } else if (data.detail && typeof data.detail === 'string') {
      errorMessage = data.detail;
    }
  }

  return errorMessage;
};
